<template>
  <v-snackbar
    v-model="snackbarProxy"
    color="primary"
    location="bottom center"
    :timeout="-1"
    rounded="lg"
    elevation="24"
    class="snack-center text-justify"
    vertical
  >
    <v-container fluid>
      <div :class="mobile ? 'font-weight-bold text-body-2' : 'font-weight-bold text-body-1'">
        {{ $t('cookies.presentation') }}
      </div>

      <Transition name="bounce">
        <v-container v-if="showOptions">
          <v-divider class="mt-2"></v-divider>

          <!-- Necessary (disabled) -->
          <v-switch
            v-model="cookie.necessary"
            color="warning"
            :disabled="true"
          >
            <template #label>
              {{ $t('cookies.necessary_label') }}
            </template>
          </v-switch>
          <div>{{ $t('cookies.necessary') }}</div>

          <!-- Statistics -->
          <v-switch
            v-model="cookie.statistics"
            color="warning"
          >
            <template #label>
              {{ $t('cookies.statistics_label') }}
            </template>
          </v-switch>
          <div>{{ $t('cookies.statistics') }}</div>
        </v-container>
      </Transition>
      

      <v-divider class="mt-2"/>

      <div class="snack-actions-inline mt-2">
        <v-btn color="error" variant="flat" class="font-weight-bold text-white"
              @click="$emit('cookie-reject')">
          <v-icon icon="mdi-alert-circle" class="mr-3" />
          {{ $t('cookies.discord') }}
        </v-btn>

        <v-btn color="warning" variant="flat" class="font-weight-bold text-white"
              @click="showOptions = !showOptions">
          <v-icon icon="mdi-cog" class="mr-3" />
          {{ $t('cookies.options') }}
        </v-btn>

        <v-btn variant="outlined" style="background-color:#C7D3DC;"
              class="font-weight-bold text-white" elevation="2"
              @click="$emit('cookie-accept', cookie)">
          <v-icon icon="mdi-cookie" class="mr-3" />
          {{ $t('cookies.agree') }}
        </v-btn>
      </div>
    </v-container>


  </v-snackbar>
</template>

<script setup>
import { ref, watch, onMounted, onBeforeUnmount } from 'vue'

const props = defineProps({
  snackbar: { type: Boolean, default: false }
})
const emit = defineEmits(['update:snackbar', 'cookie-accept', 'cookie-reject'])

const snackbarProxy = ref(props.snackbar)
const mobile = ref(false)
const showOptions = ref(false)
const cookie = ref({ necessary: true, statistics: true })

// sincronizar v-model
watch(() => props.snackbar, (val) => {
  snackbarProxy.value = val
})
watch(snackbarProxy, (val) => {
  emit('update:snackbar', val)
})

function checkMobile () {
  mobile.value = window.innerWidth <= 760
}
function handleResize () {
  checkMobile()
}

onMounted(() => {
  checkMobile()
  window.addEventListener('resize', handleResize)
})
onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize)
})
</script>

<style scoped>
/* se o bloco tiver <style scoped> usa ::v-deep */
::v-deep(.snack-center .v-snackbar__actions) {
  margin-left: 0 !important;            /* LTR */
  margin-right: 0 !important;           /* fallback */
  margin-inline-start: 0 !important;    /* LTR/RTL */
  width: 100%;
  display: flex;
  justify-content: center !important;   /* centra os botões */
}

/* layout dos teus botões (numa linha, centrados, com gap) */
.snack-actions-inline {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap; /* quebra em ecrãs estreitos */
}
.snack-center .v-snackbar__actions.v-snackbar__actions {
  margin-inline-start: 0 !important;
  margin-left: 0 !important;
  justify-content: center !important;
  width: 100%;
}
.text-white { color: white !important; }
</style>